import React from "react";
import { Form, Button, Container } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { ProfileEditFormProps } from "./profile-edit-form.props";
import { AvatarInput, PasswordInputGroup } from "@/shared/ui";

export const ProfileEditForm: React.FC<ProfileEditFormProps> = ({
  formUser,
  handleChange,
  handlePhoneChange,
  handleAvatarChange,
  handleRemoveAvatar,
  showCurrentPassword,
  setShowCurrentPassword,
  showNewPassword,
  setShowNewPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  isValidPhone,
  validated,
  loading,
  onCancel,
  buttonRef,
  handleSubmit,
}) => {
  return (
    <Container className="mt-4" style={{ maxWidth: 600 }}>
      <h2>Редактирование профиля</h2>
      <Form className="mt-4" noValidate validated={validated} onSubmit={handleSubmit}>
        <AvatarInput
          avatarUrl={formUser.avatarUrl || null}
          firstName={formUser.firstName || ""}
          onAvatarChange={handleAvatarChange}
          onRemoveAvatar={handleRemoveAvatar}
        />

        <Form.Group className="my-3">
          <Form.Label>Имя</Form.Label>
          <Form.Control
            className="rounded-5"
            name="firstName"
            value={formUser.firstName || ""}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Фамилия</Form.Label>
          <Form.Control
            className="rounded-5"
            name="lastName"
            value={formUser.lastName || ""}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Номер телефона</Form.Label>
          <PhoneInput
            country={"ru"}
            disableDropdown
            onlyCountries={["ru"]}
            masks={{ ru: "(...) ...-..-.." }}
            value={String(formUser.phone || "")}
            onChange={handlePhoneChange}
            inputClass={`form-control rounded-5 ${
              validated && !isValidPhone(formUser.phone) ? "is-invalid" : ""
            }`}
          />
          {validated && !isValidPhone(formUser.phone) && (
            <div className="invalid-feedback">Введите корректный номер телефона.</div>
          )}
        </Form.Group>

        <PasswordInputGroup
          label="Текущий пароль"
          value={formUser.currentPassword || ""}
          name="currentPassword"
          onChange={handleChange}
          showPassword={showCurrentPassword}
          toggleShow={() => setShowCurrentPassword(!showCurrentPassword)}
          placeholder="Текущий пароль"
          helpText="Заполните, если хотите изменить пароль."
        />

        <PasswordInputGroup
          label="Новый пароль"
          value={formUser.newPassword || ""}
          name="newPassword"
          onChange={handleChange}
          showPassword={showNewPassword}
          toggleShow={() => setShowNewPassword(!showNewPassword)}
          placeholder="Новый пароль"
        />

        <PasswordInputGroup
          label="Подтвердите новый пароль"
          value={formUser.confirmPassword || ""}
          name="confirmPassword"
          onChange={handleChange}
          showPassword={showConfirmPassword}
          toggleShow={() => setShowConfirmPassword(!showConfirmPassword)}
          placeholder="Подтверждение"
          isInvalid={validated && formUser.newPassword !== formUser.confirmPassword}
          feedback="Пароли не совпадают."
        />

        <div className="d-flex gap-2 mt-4">
          <Button ref={buttonRef} variant="outline-secondary" type="submit" disabled={loading}>
            {loading ? "Сохранение..." : "Сохранить"}
          </Button>
          <Button variant="secondary" onClick={onCancel} type="button">
            Отмена
          </Button>
        </div>
      </Form>
    </Container>
  );
};
